import React, { useState, useEffect, useContext } from 'react';
import '../assets/css/layouts/admin/AdminLayout.css';
import AdminSidebar from '../components/admin/sidebar/AdminSidebar';
import AdminTopbar from '../components/admin/topbar/AdminTopbar';
import MyContext from '../context/MyContext';

const AdminLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const{setAuthToken}=useContext(MyContext);
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) setIsMobileOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
    useEffect(() => {
      const authToken = localStorage.getItem("authToken");
      setAuthToken(authToken);
    }, []);

  return (
    <div className="adm-layout">
      <AdminSidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        isMobile={isMobile}
      />
      <div
        className={[
          'adm-main',
          !isMobile && isCollapsed ? 'adm-main--collapsed' : '',
          isMobile ? 'adm-main--mobile' : '',
        ].filter(Boolean).join(' ')}
      >
        <AdminTopbar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
          isMobile={isMobile}
        />
        <div className="adm-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
